export default {"src":"/_next/static/media/close.cb501375.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};